import LabeledTextInput from "./LabeledTextInput";
import type { LabeledTextInputHandler, LabeledTextInputProps } from "./types";

export default LabeledTextInput;
export type { LabeledTextInputHandler, LabeledTextInputProps };
